import axios from 'axios';
const Axios = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/api/hr`
});
Axios.interceptors.request.use(function (config) {
    const token = window.localStorage.getItem("4r7ur2");
    config.headers.Authorization = token ? `Bearer ${token}` : '';
    return config;
});

Axios.interceptors.response.use(response => {

    return response;


}, error => {
    if (error.response.status === 401) {
        window.localStorage.removeItem("4r7ur2");
        setTimeout(() => {
            window.location.reload(false);
        }, 500);
    }

});


export default Axios;
